import { type ReactNode } from 'react';
// import Footer from '@/components/footer';
import AppBar from '@/components/appbar';
import { useAuth } from '@/hooks/auth';
import { LoadingBar } from './common/loading';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import { TagsModalProvider } from '@/components/profile/context';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { authorized } = useAuth();
  const location = useLocation();
  const noLoginRequired = location.pathname === '/login';

  return (
    <TagsModalProvider>
      <div className='relative flex h-screen flex-col bg-background text-foreground light'>
        {authorized === undefined && (
          <div>
            <LoadingBar loading={true} />
          </div>
        )}
        {(authorized || noLoginRequired) && (
          <>
            <AppBar />

            <main className='w-full max-w-[100%] flex-grow px-4 pb-12 pt-4 md:px-6 lg:px-8 xl:px-10'>
              {children}
            </main>
            {/* <Footer /> */}
          </>
        )}
        {authorized === undefined && (
          <div className='relative top-20 flex flex-col items-center'>
            <Icon
              icon='svg-spinners:3-dots-rotate'
              width='24'
              height='24'
              className='text-default-600'
            />
            <div className='text-center text-2xl text-default-600'>
              Let&apos;s go!
            </div>
          </div>
        )}
      </div>
    </TagsModalProvider>
  );
}
